import { useEffect } from 'react';

export const useNetwork = ({ setState }) => {
  const onNetworkChange = ({ type }) => {
    if (type === 'online') {
      setState((draft) => {
        draft.isRefreshed = true;
      });
    }
  };

  useEffect(() => {
    window.addEventListener('online', onNetworkChange);
    window.addEventListener('offline', onNetworkChange);
    return () => {
      window.removeEventListener('online', onNetworkChange);
      window.removeEventListener('offline', onNetworkChange);
    };
  }, []);

  return { onNetworkChange };
};
